import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

const centeredButtonStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center' as const,
  whiteSpace: 'nowrap' as const,
  minWidth: '150px',
  minHeight: '36px',
  padding: '6px 16px',
  lineHeight: 1.5,
  flexShrink: 0,
};

export const AvatarButton = styled(Button)(({ theme }) => ({
  ...centeredButtonStyles,
  color: theme.palette.text.secondary,
  borderColor: theme.palette.text.secondary,
  textTransform: 'none'
}));

export const AvatarLoadingButton = styled(LoadingButton)(({ theme }) => ({
  ...centeredButtonStyles,
  color: theme.palette.text.secondary,
  borderColor: theme.palette.text.secondary,
  textTransform: 'none'
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  ...centeredButtonStyles,
  color: theme.palette.red.main,
  borderColor: theme.palette.red.main,
  textTransform: 'none'
}));

export const DeleteButton = styled(LoadingButton)(({ theme }) => ({
  ...centeredButtonStyles,
  color: theme.palette.text.secondary,
  borderColor: theme.palette.text.secondary,
  textTransform: 'none',
  textDecoration: 'underline',
  fontWeight: '400'
}));
